import { ExamHistory } from '../../store/workspace/types';
import styles from './style.module.scss';
import { camelCaseToSpacedString } from '../../utils/generalHelpers';
import { AshbyLogoIcon, MenuBoardIcon } from '../../assets/icons/common';

interface Props {
    showStatus?: boolean;
    jobDetail: ExamHistory;
};

export default function InterviewCard(props: Props) {
    const { jobDetail, showStatus } = props;

    const getDeadline = () => {
        if (!jobDetail.multipleChoiceExamDeadline) return null;

        const [month, day, year] = jobDetail.multipleChoiceExamDeadline.split('-');
        const deadline = new Date(Number(year), Number(month) - 1, Number(day));
        const today = new Date();
        const diffTime = deadline.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays <= 10 && diffDays > 0
            ? <b data-text-color='red'>({`${diffDays} day${diffDays > 1 ? 's' : ''} left`})</b>
            : null
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.company_detail}>
                    <div className={styles.company_detail_logo}>
                        {jobDetail.companyLogo ? <img src={jobDetail.companyLogo} alt="" /> : <span>{jobDetail.companyName?.slice(0, 1)}</span>}
                    </div>
                    <div className={styles.company_detail_name}>
                        <span>{jobDetail.companyName}</span>
                        {jobDetail.platform === 'Ashby' && <AshbyLogoIcon width={71} height={23} />}
                    </div>
                </div>

                {showStatus && jobDetail.finalize &&
                    <div className={styles.status}>
                        <span>{camelCaseToSpacedString(jobDetail.finalize)}</span>
                    </div>}

                {jobDetail.multipleChoiceExamDeadline &&
                    <div className={styles.deadline}>
                        <MenuBoardIcon />
                        <span>Deadline: </span>
                        <b>{jobDetail.multipleChoiceExamDeadline}</b>
                        {getDeadline()}
                    </div>}

            </div>
            <div className={styles.job_detail}>
                <div className={styles.row}>
                    <span className={styles.row_text} data-is-bold="true">{jobDetail.title}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>Job type: {jobDetail.jobType}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        Base salary amount: {jobDetail.baseSalaryAmount || '---'}$ /{jobDetail.baseSalaryFrequency}
                    </span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        {jobDetail.city} / {jobDetail.state} / {jobDetail.country}
                    </span>
                </div>
            </div>
        </div>
    )
};
